import ReactSelect from 'react-select';
import { useChartsDataContext } from './hooks/useChartsDataContext';
import { useBanks } from './hooks/useBanks';

const getYears = () => {
    const years = [];
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 20; i++) {
        years.push({
            value: currentYear - i,
            label: currentYear - i
        });
    }
    return years;
};

const months = [
    { value: '01', label: 'Janeiro' },
    { value: '02', label: 'Fevereiro' },
    { value: '03', label: 'Março' },
    { value: '04', label: 'Abril' },
    { value: '05', label: 'Maio' },
    { value: '06', label: 'Junho' },
    { value: '07', label: 'Julho' },
    { value: '08', label: 'Agosto' },
    { value: '09', label: 'Setembro' },
    { value: '10', label: 'Outubro' },
    { value: '11', label: 'Novembro' },
    { value: '12', label: 'Dezembro' }
];

export const Filters = () => {
    const { state, fetchChartData, handleChangeFilter } =
        useChartsDataContext();
    const banks = useBanks();

    return (
        <form id="crudform">
            <div className="card-body">
                <div className="row">
                    <div className="form-group col-sm-3">
                        <label htmlFor={'bank'}>Conta</label>
                        <ReactSelect
                            name={'bank'}
                            onChange={(element) => {
                                if (element) {
                                    handleChangeFilter({
                                        pdc_bank_account_id: element.value
                                    });
                                } else {
                                    handleChangeFilter({
                                        pdc_bank_account_id: ''
                                    });
                                }
                            }}
                            options={banks}
                            isClearable={true}
                        />
                    </div>
                    <div className="form-group col-sm-2">
                        <label htmlFor={'month'}>Mês</label>
                        <ReactSelect
                            name={'month'}
                            onChange={(element) => {
                                if (element) {
                                    handleChangeFilter({
                                        month: element.value
                                    });
                                } else {
                                    handleChangeFilter({
                                        month: ''
                                    });
                                }
                            }}
                            options={months}
                            isClearable={true}
                        />
                    </div>
                    <div className="form-group col-sm-2">
                        <label htmlFor={'year'}>Ano</label>
                        <ReactSelect
                            name={'year'}
                            onChange={(element) => {
                                handleChangeFilter({
                                    year: element.value
                                });
                            }}
                            options={getYears()}
                            value={{
                                value: state.filters.year,
                                label: state.filters.year
                            }}
                        />
                    </div>
                    <div className="form-group col-sm-1">
                        <label>&nbsp;</label>
                        <div>
                            <button
                                onClick={() => fetchChartData()}
                                type="button"
                                className="btn btn-primary"
                            >
                                Pesquisar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-footer d-flex justify-content-end"></div>
        </form>
    );
};
